import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common'; 
import { SwUpdate } from '@angular/service-worker';
import { NotificationService } from './notification_service';

interface BeforeInstallPromptEvent extends Event {
  readonly platforms: Array<string>;
  readonly userChoice: Promise<{
    outcome: 'accepted' | 'dismissed';
    platform: string;
  }>;
  prompt(): Promise<void>;
}

@Injectable({
  providedIn: 'root'
})
export class PwaService {
  private swUpdate = inject(SwUpdate);
  private notificationService = inject(NotificationService);
  private platformId = inject(PLATFORM_ID);
  
  promptEvent: BeforeInstallPromptEvent | null = null;

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.setupBrowserListeners();
    }
  }

  private setupBrowserListeners(): void {
    window.addEventListener('beforeinstallprompt', (event) => {
      this.promptEvent = event as BeforeInstallPromptEvent; 
      console.log('PwaService: beforeinstallprompt intercepted.');
    });

    this.swUpdate.versionUpdates.subscribe(() => {
      this.notificationService.notify({
        message: 'There is new update available for Notd',
        type: 'success',
        button: {
          label: 'Update',
          action: 'makePwaAppUpdate'
        }
      });
    });
  }

  public showInstallPrompt(): void {
    if (this.promptEvent) {
      this.promptEvent.prompt();
      this.promptEvent.userChoice.then((choiceResult) => { 
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the PWA install prompt');
        } else {
          console.log('User dismissed the PWA install prompt');
        }
        this.promptEvent = null;
      });
    }
  }

  public isInstallPromptAvailable(): boolean {
    return isPlatformBrowser(this.platformId) && this.promptEvent !== null;
  }
}